import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.4rem;

  .novidade-tarja {
    font-size: 0.9rem;
    font-weight: 700;
    color: var(--white);
    background-color: var(--red);
    border-radius: 0.2rem;
    padding: 0 0.1rem;
    height: max-content;
  }

  .promotion-selo {
    border-radius: 0.2rem;
  }

  .product-tarjas {
    display: flex;
    gap: 0.4rem;

    .tarjas {
      padding: 0.3rem 1rem;
      font-weight: 700;
      color: var(--white);
      border-radius: 0.4rem;
      user-select: none;
      font-size: 0.9rem;
    }

    .frete-gratis-tag {
      max-width: 7rem;
    }

    .ganhe-brinde-tarja {
      background: var(--gradient_green);
      width: max-content;
    }
  }
`;
